import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { useContentStore } from '@/stores/content.store'
import { useFrontpageStore } from '@/stores/frontpage.store'
import type { SeoSource } from '@/utils/seo'

function normalizeRouteName(name: unknown) {
  return typeof name === 'string' ? name.replace(/-(en|no)$/, '') : ''
}

function routeParamString(value: unknown) {
  return typeof value === 'string' ? value : ''
}

export function useRouteSeoContent() {
  const route = useRoute()
  const contentStore = useContentStore()
  const frontpageStore = useFrontpageStore()

  const { attachments, gyms, pages, posts, trainers } = storeToRefs(contentStore)
  const { frontpage } = storeToRefs(frontpageStore)

  const currentRouteContent = computed<SeoSource | null>(() => {
    const routeName = normalizeRouteName(route.name)
    const slug = routeParamString(route.params.slug)

    switch (routeName) {
      case 'home': {
        const frontpageId = frontpage.value?.frontpage_id
        if (typeof frontpageId !== 'number') return null
        return pages.value.find((page) => page.id === frontpageId) ?? null
      }
      case 'page':
        return pages.value.find((page) => page.slug === slug) ?? null
      case 'gym':
        return gyms.value.find((gym) => gym.slug === slug) ?? null
      case 'trainer':
        return trainers.value.find((trainer) => trainer.slug === slug) ?? null
      case 'campaign':
      case 'post':
        return posts.value.find((post) => post.slug === slug) ?? null
      default:
        return null
    }
  })

  return {
    attachments,
    currentRouteContent,
  }
}
